import { Routes, Route } from "react-router-dom";
import Clientlogin from "./components/Clientpanel/Auth/Login";
import ClientEmailBuilderlist from "./components/Clientpanel/EmailBuilder/List";
/* import ClientEmailBuilderform from "./components/Clientpanel/EmailBuilder/Form"; */
import ClientEmailBuilderform from "./components/Clientpanel/EmailBuilder/NewEditor";

import Emailcampaignlist from "./components/Clientpanel/Emailcampaign/List";
import Emailcampaignform from "./components/Clientpanel/Emailcampaign/Form";
import Tablemanagementlist from "./components/Clientpanel/Tablemanagement/List";
import Tablemanagementform from "./components/Clientpanel/Tablemanagement/Form";
import Rating from "./components/Clientpanel/Rating/List";

import SMScampaignlist from "./components/Clientpanel/SMScampaign/List";
import SMScampaignform from "./components/Clientpanel/SMScampaign/Form";
import ClientHolidayList from "./components/Clientpanel/Holiday/List";
import ClientHolidayForm from "./components/Clientpanel/Holiday/Form";

import ClntWhatsapptemplatelist from "./components/Clientpanel/Whatsapptemplate/List";
import ClntWhatsapptemplateform from "./components/Clientpanel/Whatsapptemplate/Templateform";
import ClntWhatsapptemplateView from "./components/Clientpanel/Whatsapptemplate/TemplateView";

import BroadcastWtlist from "./components/Clientpanel/BroadcastWhatsappMsg/List";
import BroadcastWtform from "./components/Clientpanel/BroadcastWhatsappMsg/Form";
import BroadcastWtCustList from "./components/Clientpanel/BroadcastWhatsappMsg/CustList";
import Spinwheelform from "./components/Clientpanel/Spinwheel/Form";
import Scratchform from "./components/Clientpanel/Scratch/Form";

import Tagslist from "./components/Clientpanel/Tags/List";
import Tagsform from "./components/Clientpanel/Tags/Form";
import Grouplist from "./components/Clientpanel/Group/List";
import Groupform from "./components/Clientpanel/Group/Form";
import Categorylist from "./components/Clientpanel/Category/List";
import Categoryform from "./components/Clientpanel/Category/Form";
import CatalogSubcategorylist from "./components/Clientpanel/CatalogSubcategory/List";
import CatalogSubcategoryform from "./components/Clientpanel/CatalogSubcategory/Form";
import CatalogProductslist from "./components/Clientpanel/Catalogs/List";
import CatalogProductsform from "./components/Clientpanel/Catalogs/Form";
import Orderlist from "./components/Clientpanel/Orders/List";
import OrderDetails from "./components/Clientpanel/Orders/Details";
import OrderReports from "./components/Clientpanel/OrderReports/List";
import Ownriderlist from "./components/Clientpanel/Ownrider/List";
import Ownriderform from "./components/Clientpanel/Ownrider/Form";
import Promotionlist from "./components/Clientpanel/Promotion/List";
import Promotionform from "./components/Clientpanel/Promotion/Form";
import Outlettagslist from "./components/Clientpanel/Outlettags/List";
import Outlettagsform from "./components/Clientpanel/Outlettags/Form";
import Zonelist from "./components/Clientpanel/Zone/List";
import Zoneform from "./components/Clientpanel/Zone/Zoneform";
import Timeslotlist from "./components/Clientpanel/Timeslot/List";
import Timeslotform from "./components/Clientpanel/Timeslot/Form";
import Pagelist from "./components/Clientpanel/Pages/List";
import Pageform from "./components/Clientpanel/Pages/Form";
import ClientEmailtemplatelist from "./components/Clientpanel/Emailtemplate/List";
import ClientEmailtemplateform from "./components/Clientpanel/Emailtemplate/Form";
import Bannerlist from "./components/Clientpanel/Banner/List";
import Bannerform from "./components/Clientpanel/Banner/Form";
import ClientStaticblocklist from "./components/Clientpanel/Staticblock/List";
import ClientStaticblockform from "./components/Clientpanel/Staticblock/Form";
import Gallerylist from "./components/Clientpanel/Gallery/List";
import Galleryform from "./components/Clientpanel/Gallery/Form";

import EcomDashboard from "./components/Clientpanel/EcomDashboard/Dashboard";
import KitchenDisplay from "./components/Clientpanel/KitchenDisplay/List";
import Notificationlist from "./components/Clientpanel/Notification/List";
import Notificationform from "./components/Clientpanel/Notification/Form";

import Clientdashboard from "./components/Clientpanel/Dashboard/Dashboard";
import Outletlist from "./components/Clientpanel/Outlet/List";
import Outletform from "./components/Clientpanel/Outlet/Form";

import Userroleslist from "./components/Clientpanel/Userroles/List";
import Userrolesform from "./components/Clientpanel/Userroles/Form";
import Userlist from "./components/Clientpanel/User/List";
import Userform from "./components/Clientpanel/User/Form";
/* import Promotionlist from "./components/Clientpanel/Promotion/List"; */
import Wallettopupplanlist from "./components/Clientpanel/Wallettopupplan/List";
import Wallettopupplanform from "./components/Clientpanel/Wallettopupplan/Form";
import Wallettopuphistorylist from "./components/Clientpanel/Wallettopuphistory/List";
import Customerlist from "./components/Clientpanel/Customer/List";
import Customerform from "./components/Clientpanel/Customer/Form";
import Customeranalytics from "./components/Clientpanel/CustomerAnalytics/List";
import Analyticsgroup from "./components/Clientpanel/CustomerAnalytics/Analyticsgroup";
import Subcategorylist from "./components/Clientpanel/Subcategory/List";
import Subcategoryform from "./components/Clientpanel/Subcategory/Form";
import Productslist from "./components/Clientpanel/Products/List";
import Productsform from "./components/Clientpanel/Products/Form";
import SubscriptionSettuplist from "./components/Clientpanel/SubscriptionSettup/List";
import SubscriptionSettupform from "./components/Clientpanel/SubscriptionSettup/Form";
import Subscriptionlist from "./components/Clientpanel/Subscription/List";
import SubscriptionSubscriptionViewt from "./components/Clientpanel/Subscription/View";
import Crmsettingsform from "./components/Clientpanel/Crmsettings/Form";
import Rewardsettingsform from "./components/Clientpanel/Rewardsettings/Form";

import Pointslist from "./components/Clientpanel/Points/List";
import Pointsform from "./components/Clientpanel/Points/Form";
import Settingsform from "./components/Clientpanel/Settings/Form";
import AdditionalCharge from "./components/Clientpanel/Settings/AdditionalCharge";

import ReferralHistory from "./components/Clientpanel/ReferralHistory/List";
import ClientCommisson from "./components/Clientpanel/Commission/List";
import Sellvoucherslist from "./components/Clientpanel/Sellvouchers/List";
import Sellvouchersform from "./components/Clientpanel/Sellvouchers/Form";
import CreditsReport from "./components/Clientpanel/Reports/CreditsReport";
import RedeemedReport from "./components/Clientpanel/Reports/RedeemedReport";
import VoucherIssuedOverview from "./components/Clientpanel/Reports/VoucherIssuedOverview";
import VoucherIssuedItemWise from "./components/Clientpanel/Reports/VoucherIssuedItemWise";


import VoucherReport from "./components/Clientpanel/Reports/VoucherReport";
import BillPayReport from "./components/Clientpanel/Reports/BillPayReport";
import TransactionReport from "./components/Clientpanel/Reports/TransactionReport";
import Influencerlist from "./components/Clientpanel/Influencer/List";
import Influencerform from "./components/Clientpanel/Influencer/Form";
import Analytics from "./components/Clientpanel/Reports/Analytics";

import ReservationRoutes from "./ReservationRoutes";
import EngageRoutes from "./EngageRoutes";
import EngageV1Routes from "./EngageV1Routes";
import EpicSocialRoutes from "./EpicSocialRoutes";

import CateringTagslist from "./components/Clientpanel/CateringTags/List";
import CateringTagsform from "./components/Clientpanel/CateringTags/Form";
import CateringMenuTypelist from "./components/Clientpanel/CateringMenuType/List";
import CateringMenuTypeform from "./components/Clientpanel/CateringMenuType/Form";
import CateringEventTypelist from "./components/Clientpanel/CateringEventType/List";
import CateringEventTypeform from "./components/Clientpanel/CateringEventType/Form";

import CateringMenulist from "./components/Clientpanel/CateringMenu/List";
import CateringMenuform from "./components/Clientpanel/CateringMenu/Form";

import CateringOrderslist from "./components/Clientpanel/CateringOrders/List";
import AdminCateringOrderDetail from "./components/Clientpanel/CateringOrders/Details";


import Referralsettingslist from "./components/Clientpanel/Referralsettings/List";
import Referralsettingsform from "./components/Clientpanel/Referralsettings/Form";
import ReferralSettingHistory from "./components/Clientpanel/ReferralSettingHistory/List";


const ClientPanelRoutes = () => {
  return (
    <Routes>
      {/*     <Route path="/" element={<<Login /> />} /> */}
      <Route index path={`login/:LoginType/:clientIDt`} element={<Clientlogin />} />
      <Route path={`login`} element={<Clientlogin />} />
      <Route path={`dashboard`} element={<Clientdashboard />} />
      <Route path={`/outlet`} element={<Outletlist />} />
      <Route path={`outlet/add`} element={<Outletform />} />
      <Route path={`outlet/edit/:EditID`} element={<Outletform />} />

      <Route path={`whatsapptemplate`} element={<ClntWhatsapptemplatelist />} />
      <Route path={`whatsapptemplate/add`} element={<ClntWhatsapptemplateform />} />
      <Route path={`whatsapptemplate/view/:templateID`} element={<ClntWhatsapptemplateView />} />

      <Route path={`broadcast`} element={<BroadcastWtlist />} />
      <Route path={`broadcast/add`} element={<BroadcastWtform />} />
      <Route path={`broadcast/edit/:EditID`} element={<BroadcastWtform />} />

      <Route path={`broadcast/view/:ViewID`} element={<BroadcastWtCustList />} />

      <Route path={`userroles`} element={<Userroleslist />} />
      <Route path={`userroles/add`} element={<Userrolesform />} />
      <Route path={`userroles/edit/:EditID`} element={<Userrolesform />} />
      <Route path={`users`} element={<Userlist />} />
      <Route path={`users/add`} element={<Userform />} />
      <Route path={`users/edit/:EditID`} element={<Userform />} />
      <Route path={`referral`} element={<ReferralHistory />} />
      <Route path={`wallettopupplan`} element={<Wallettopupplanlist />} />
      <Route path={`wallettopupplan/add`} element={<Wallettopupplanform />} />
      <Route path={`wallettopupplan/edit/:EditID`} element={<Wallettopupplanform />} />
      <Route path={`wallettopuphistory`} element={<Wallettopuphistorylist />} />
      <Route path={`crmsettings`} element={<Crmsettingsform />} />
      <Route path={`rewardsettings`} element={<Rewardsettingsform />} />
      <Route path={`customers`} element={<Customerlist />} />
      <Route path={`customers/add`} element={<Customerform />} />
      <Route path={`customers/edit/:EditID`} element={<Customerform />} />
      <Route path={`customeranalytics`} element={<Customeranalytics />} />
      <Route path={`analyticsgroup`} element={<Analyticsgroup />} />
      <Route path={`catalog-subcategories`} element={<Subcategorylist />} />
      <Route path={`catalog-subcategories/add`} element={<Subcategoryform />} />
      <Route path={`catalog-subcategories/edit/:EditID`} element={<Subcategoryform />} />
      <Route path={`catalog-products`} element={<Productslist />} />
      <Route path={`catalog-products/add`} element={<Productsform />} />
      <Route path={`catalog-products/edit/:EditID`} element={<Productsform />} />
      <Route path={`subscription-settup`} element={<SubscriptionSettuplist />} />
      <Route path={`subscription-settup/add`} element={<SubscriptionSettupform />} />
      <Route path={`subscription-settup/edit/:EditID`} element={<SubscriptionSettupform />} />
      <Route path={`subscription`} element={<Subscriptionlist />} />
      <Route path={`subscription/view/:EditID`} element={<SubscriptionSubscriptionViewt />} />
      <Route path={`spinwheel`} element={<Spinwheelform />} />
      <Route path={`scratch`} element={<Scratchform />} />
      

      <Route path={`points`} element={<Pointslist />} />
      <Route path={`points/:Type`} element={<Pointsform />} />
      <Route path={`settings`} element={<Settingsform />} />
      <Route path={`additional-charge`} element={<AdditionalCharge />} />
      <Route path={`commission`} element={<ClientCommisson />} />
      <Route path={`sell-vouchers`} element={<Sellvoucherslist />} />
      <Route path={`sell-vouchers/add`} element={<Sellvouchersform />} />
      <Route path={`sell-vouchers/edit/:EditID`} element={<Sellvouchersform />} />
      <Route path={`credits-report`} element={<CreditsReport />} />
      <Route path={`redeemed-report`} element={<RedeemedReport />} />
      <Route path={`voucher-issued-overview-report`} element={<VoucherIssuedOverview />} />
      <Route path={`voucher-issued-item-wise-report`} element={<VoucherIssuedItemWise />} />
      
      
      <Route path={`sell-voucher-report`} element={<VoucherReport />} />
      <Route path={`bill-pay-report`} element={<BillPayReport />} />
      <Route path={`transaction-report`} element={<TransactionReport />} />

      <Route path={`analytics`} element={<Analytics />} />

      <Route path={`influencer`} element={<Influencerlist />} />
      <Route path={`influencer/add`} element={<Influencerform />} />
      <Route path={`influencer/edit/:EditID`} element={<Influencerform />} />
      <Route path={`emailBuilder`} element={<ClientEmailBuilderlist />} />
      <Route path={`emailBuilder/add`} element={<ClientEmailBuilderform />} />
      <Route path={`emailBuilder/edit/:TemplateID`} element={<ClientEmailBuilderform />} />
      <Route path={`emailcampaign`} element={<Emailcampaignlist />} />
      <Route path={`emailcampaign/add`} element={<Emailcampaignform />} />
      <Route path={`emailcampaign/edit/:EditID`} element={<Emailcampaignform />} />
      <Route path={`smscampaign`} element={<SMScampaignlist />} />
      <Route path={`smscampaign/add`} element={<SMScampaignform />} />
      <Route path={`smscampaign/edit/:EditID`} element={<SMScampaignform />} />

      <Route path={`holiday`} element={<ClientHolidayList />} />
      <Route path={`holiday/add`} element={<ClientHolidayForm />} />
      <Route path={`holiday/edit/:EditID`} element={<ClientHolidayForm />} />

      <Route path={`table`} element={<Tablemanagementlist />} />
      <Route path={`table/add`} element={<Tablemanagementform />} />
      <Route path={`table/edit/:EditID`} element={<Tablemanagementform />} />

      <Route path={`ecom-tag`} element={<Tagslist />} />
      <Route path={`ecom-tag/add`} element={<Tagsform />} />
      <Route path={`ecom-tag/edit/:EditID`} element={<Tagsform />} />
      <Route path={`ecom-group`} element={<Grouplist />} />
      <Route path={`ecom-group/add`} element={<Groupform />} />
      <Route path={`ecom-group/edit/:EditID`} element={<Groupform />} />
      <Route path={`ecom-categories`} element={<Categorylist />} />
      <Route path={`ecom-categories/add`} element={<Categoryform />} />
      <Route path={`ecom-categories/edit/:EditID`} element={<Categoryform />} />
      <Route path={`ecom-subcategories`} element={<CatalogSubcategorylist />} />
      <Route path={`ecom-subcategories/add`} element={<CatalogSubcategoryform />} />
      <Route path={`ecom-subcategories/edit/:EditID`} element={<CatalogSubcategoryform />} />
      <Route path={`ecom-products`} element={<CatalogProductslist />} />
      <Route path={`ecom-products/add`} element={<CatalogProductsform />} />
      <Route path={`ecom-products/edit/:EditID`} element={<CatalogProductsform />} />
      <Route path={`promotions`} element={<Promotionlist />} />
      <Route path={`promotions/add`} element={<Promotionform />} />
      <Route path={`promotions/edit/:EditID`} element={<Promotionform />} />
      <Route path={`order/:orderType/:orderID`} element={<OrderDetails />} />
      <Route path={`order/:orderType`} element={<Orderlist />} />
      <Route path={`order/:orderType`} element={<Orderlist />} />
      <Route path={`order-reports`} element={<OrderReports />} />
      <Route path={`own-rider`} element={<Ownriderlist />} />
      <Route path={`own-rider/add`} element={<Ownriderform />} />
      <Route path={`own-rider/edit/:EditID`} element={<Ownriderform />} />
      <Route path={`outlet-tag`} element={<Outlettagslist />} />
      <Route path={`outlet-tag/add`} element={<Outlettagsform />} />
      <Route path={`outlet-tag/edit/:EditID`} element={<Outlettagsform />} />
      <Route path={`zone`} element={<Zonelist />} />
      <Route path={`zone/add`} element={<Zoneform />} />
      <Route path={`zone/edit/:EditID`} element={<Zoneform />} />
      <Route path={`timeslot`} element={<Timeslotlist />} />
      <Route path={`timeslot/add`} element={<Timeslotform />} />
      <Route path={`timeslot/edit/:EditID`} element={<Timeslotform />} />
      <Route path={`pages`} element={<Pagelist />} />
      <Route path={`pages/add`} element={<Pageform />} />
      <Route path={`pages/edit/:EditID`} element={<Pageform />} />
      <Route path={`emailtemplate`} element={<ClientEmailtemplatelist />} />
      <Route path={`emailtemplate/add`} element={<ClientEmailtemplateform />} />
      <Route path={`emailtemplate/edit/:EditID`} element={<ClientEmailtemplateform />} />
      <Route path={`banner`} element={<Bannerlist />} />
      <Route path={`banner/add`} element={<Bannerform />} />
      <Route path={`banner/edit/:EditID`} element={<Bannerform />} />
      <Route path={`staticblock`} element={<ClientStaticblocklist />} />
      <Route path={`staticblock/add`} element={<ClientStaticblockform />} />
      <Route path={`staticblock/edit/:EditID`} element={<ClientStaticblockform />} />
      <Route path={`gallery`} element={<Gallerylist />} />
      <Route path={`gallery/add`} element={<Galleryform />} />
      <Route path={`gallery/edit/:EditID`} element={<Galleryform />} />
      <Route path={`ecom-dashboard`} element={<EcomDashboard />} />
      <Route path={`kitchen-display`} element={<KitchenDisplay />} />
      <Route path={`notification`} element={<Notificationlist />} />
      <Route path={`notification/add`} element={<Notificationform />} />
      <Route path={`notification/edit/:EditID`} element={<Notificationform />} />
      
      <Route path="reservation/*" element={<ReservationRoutes />} />
      <Route path="enage/*" element={<EngageRoutes />} />
      <Route path="enagev1/*" element={<EngageV1Routes />} />
      <Route path="epicsocial/*" element={<EpicSocialRoutes />} />      
      <Route path={`catering-tags`} element={<CateringTagslist />} />
      <Route path={`catering-tags/add`} element={<CateringTagsform />} />
      <Route path={`catering-tags/edit/:EditID`} element={<CateringTagsform />} />
      <Route path={`catering-menu-type`} element={<CateringMenuTypelist />} />
      <Route path={`catering-menu-type/add`} element={<CateringMenuTypeform />} />
      <Route path={`catering-menu-type/edit/:EditID`} element={<CateringMenuTypeform />} />
      <Route path={`catering-event`} element={<CateringEventTypelist />} />
      <Route path={`catering-event/add`} element={<CateringEventTypeform />} />
      <Route path={`catering-event/edit/:EditID`} element={<CateringEventTypeform />} />
      <Route path={`catering-menu`} element={<CateringMenulist />} />
      <Route path={`catering-menu/add`} element={<CateringMenuform />} />
      <Route path={`catering-menu/edit/:EditID`} element={<CateringMenuform />} />
      <Route path="/catering/orders" element={<CateringOrderslist />} />
      <Route path="/catering/orders/:id" element={<AdminCateringOrderDetail />} />

      <Route path={`referralsettings`} element={<Referralsettingslist />} />
      <Route path={`referralsettings/add`} element={<Referralsettingsform />} />
      <Route path={`referralsettings/edit/:EditID`} element={<Referralsettingsform />} />
      <Route path={`referralsettinghistory`} element={<ReferralSettingHistory />} />
      

      <Route path={`rating/setting`} element={<Rating />} />
      <Route path={`rating`} element={<Rating />} />
    </Routes>
  );
};

export default ClientPanelRoutes;
